/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: WizardStep
 * Reason: Step 1 of POC wizard - collect basics (name, alias, logic group, description)
 */
import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {LgPocWizardStateService} from '../../../../service/domain/lg-poc-wizard-state/lg-poc-wizard-state.service';
import {MvsCoreService} from '../../../../../../core/shared/service/mvs-core.service';
import {ObjectRequestList} from '../../../../../../core/shared/dto/object/request/object-request-list';

interface LogicGroupOption {
    label: string;
    value: number;
}

@Component({
    selector: 'lg-poc-wizard-step-basics',
    templateUrl: './lg-poc-wizard-step-basics.component.html',
    styleUrls: ['./lg-poc-wizard-step-basics.component.scss'],
    standalone: false
})
export class LgPocWizardStepBasicsComponent implements OnInit, OnDestroy {

    name: string = '';
    alias: string = '';
    description: string = '';
    logicGroupId: number;

    logicGroups: LogicGroupOption[] = [];
    loadingGroups: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(
        private wizardState: LgPocWizardStateService,
        private coreService: MvsCoreService
    ) {
    }

    ngOnInit(): void {
        this.loadLogicGroups();

        // Restore state if going back
        const state = this.wizardState.state;
        if (state.name) {
            this.name = state.name;
            this.alias = state.alias || '';
            this.description = state.description || '';
            this.logicGroupId = state.logicGroupId;
        }
    }

    loadLogicGroups(): void {
        this.loadingGroups = true;
        const objectRequest = ObjectRequestList.createBasic(false, [], []);

        const crudService = this.coreService.getCrudService('lg.LogicGroup');
        const sub = crudService.list(objectRequest).subscribe({
            next: (result: any) => {
                this.logicGroups = result.entries?.map((entry: any) => ({
                    label: entry.name || entry.internalName,
                    value: entry.id
                })) || [];
                this.loadingGroups = false;
            },
            error: () => {
                this.loadingGroups = false;
            }
        });
        this.subscriptions.push(sub);
    }

    onNameChange(): void {
        this.alias = this.generateAlias(this.name);
    }

    generateAlias(name: string): string {
        if (!name) return '';
        let result = name.toLowerCase();
        result = result.replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
        result = result.replace(/[^a-z0-9]+/g, '_');
        result = result.replace(/^_+|_+$/g, '');
        return result.substring(0, 80);
    }

    get isValid(): boolean {
        return !!this.name?.trim();
    }

    onNext(): void {
        if (!this.isValid) return;

        this.wizardState.completeStep1({
            name: this.name.trim(),
            alias: this.alias,
            logicGroupId: this.logicGroupId,
            description: this.description
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
